import { render, staticRenderFns } from "./PartnerTypeBadges.vue?vue&type=template&id=6049d6af"
import script from "./PartnerTypeBadges.vue?vue&type=script&lang=js"
export * from "./PartnerTypeBadges.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports